import React from "react";
import { ClipboardCheckIcon, FileTextIcon, FilterIcon, GitForkIcon, MapIcon, PrinterIcon } from "lucide-react";
import { toolkit } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaButton } from "../ui/CtaButton";
const icons = [MapIcon, GitForkIcon, FileTextIcon, FilterIcon, ClipboardCheckIcon, PrinterIcon];
export function ToolkitSection() {
  return <section className="bg-navydeep px-5 py-16 sm:py-24" data-id="element-274" data-mp="12ozm0z7dy3wm">
      <div className="mx-auto max-w-5xl" data-id="element-275" data-mp="12qkk2ysws4z8">
        <SectionHeading tone="dark" eyebrow="Plus, Your Complete Endo Reference Toolkit" title="The Six Volumes Are Only the Beginning" subtitle="Practical resources designed to make the visual framework easier to navigate and use." data-id="element-276" data-mp="xxrgwfd394p9" />
        <ul className="mt-10 grid gap-x-10 sm:grid-cols-2" data-id="element-277" data-mp="jyrpx123sdpx">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex gap-4 border-b border-white/10 py-5" data-id="element-278" data-mp="ezx55tkksf36" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cyan/15 text-cyan" data-id="element-279" data-mp="f9r9nlq92zod">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-280" data-mp="k453hjp9kyqx" />
                </span>
                <div data-id="element-281" data-mp="6cguvqe84sep">
                  <h3 className="text-lg font-bold text-white" data-id="element-282" data-mp="b9qh6x6bgnyb">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-283" data-mp="b9yxz05k8des">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>
        <div className="mt-12" data-id="element-284" data-mp="12zvajlc20lbo">
          <CtaButton label="Get Access to All 6 Volumes" size="md" data-id="element-285" data-mp="12ysk1ein8kwa" />
        </div>
      </div>
    </section>;
}